import { useHistory } from 'react-router-dom';

import { rewritePathfield } from 'features/travel_insurance/utils/rewritePathfield';
const checkoutPage = process.env.REACT_APP_PAGE_CARRINHO;

export const useRedirectCheckout = () => {
  const history = useHistory();
  const handleRedirectCheckout = (searchParams?: string) => {
    if (checkoutPage) {
      if (searchParams) {
        history.push({
          pathname: rewritePathfield(checkoutPage),
          search: searchParams,
        });
      } else {
        history.push(rewritePathfield(checkoutPage));
      }
    }
  };

  return { handleRedirectCheckout };
};
